import React from "react";
import Header from "../component/Header";
import Carousel from "../component/Carousel";
import Courses from "../component/Courses";
import RelatedPrograms from "../component/RelatedPrograms";
import StudentReview from "../component/StudentReview";
import LatestBlog from "../component/LatestBlog";
import WhySkillara from "../component/whySkillara";
import HowSkillara from "../component/HowSkillara";
import WhatSkillara from "../component/WhatSkillara";
import CorporateClients from "../component/CorporateClients";
import Footer from "../component/Footer";
import WhatsAppButton from "../component/WhatsappIntegration";
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    // This runs every time the URL hash changes (e.g., /#student-reviews or /#blog)
    if (location.hash) {
      setTimeout(() => {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location]);

  return (
    <div>
      <Carousel />
      <Courses />
      <RelatedPrograms />

      <WhySkillara />
      
 <HowSkillara />



 <WhatSkillara />


      <div id="blog">
        <LatestBlog />
      </div>

      <div id="student-reviews">
        <StudentReview />
      </div>

      {/* <CorporateClients/> */}
      {/* <WhatsAppButton/> */}





    </div>
  );
};

export default Home;